import { render, staticRenderFns } from "./batchEditForm.vue?vue&type=template&id=3916a6b2&"
import script from "./batchEditForm.vue?vue&type=script&lang=js&"
export * from "./batchEditForm.vue?vue&type=script&lang=js&"
import style0 from "./batchEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "batchEditForm.vue"
export default component.exports